<template >
    <v-dialog  v-model="display" width=500 :persistent="true" >
        <v-card>
            <v-card-title>
                <str :index="popupTitle"/>
            </v-card-title>

            <v-card-text>
                <str :index="popupMessage"/>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                    <v-btn color=#0090C1 @click="dismiss=true;$emit('dismiss');"><str style="color:white;" :index="buttonText"/></v-btn>
                <v-spacer/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import _isEmpty from 'lodash/isEmpty';

export default {
    name: "SimplePopup",
    props: {
        title: {
            required: true,
            default: null
        },
        message: {
            required: true,
            default: null
        },
        buttonText: {
            type: String,
            required: false,
            default: 'button > dismiss'
        }
    },
    data: function(){
        return {
            dismiss: false,
        }
    },
            
    methods: {
       
    },
    computed: {
        display: function(){
            if (_isEmpty(this.title)===false || _isEmpty(this.message)===false){
                return true;
            }
            
            return false;
        },
        popupTitle: function(){
            return (_isEmpty(this.title)===false) ? this.title : "message > void placeholder";
        },
        popupMessage: function(){
            return (_isEmpty(this.message)===false) ? this.message : "message > void placeholder";
        }         
    }
}
</script>

<style>

</style>